module.exports = __webpack_public_path__ + "img/index.c46c0d1d.png";